/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaVnfSecuredConfiguration } from '../shiva-vnf-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DockDailyOccupancyStateList } from '../models/dock-daily-occupancy-state-list';
import { GescalesRawDataProgress } from '../models/gescales-raw-data-progress';
import { getGescalesRawDataProcessProgress } from '../fn/vnf-dashboard/get-gescales-raw-data-process-progress';
import { GetGescalesRawDataProcessProgress$Params } from '../fn/vnf-dashboard/get-gescales-raw-data-process-progress';
import { getOccupancyState } from '../fn/vnf-dashboard/get-occupancy-state';
import { GetOccupancyState$Params } from '../fn/vnf-dashboard/get-occupancy-state';
import { importGescalesData } from '../fn/vnf-dashboard/import-gescales-data';
import { ImportGescalesData$Params } from '../fn/vnf-dashboard/import-gescales-data';
import { upsertGescalesDock } from '../fn/vnf-dashboard/upsert-gescales-dock';
import { UpsertGescalesDock$Params } from '../fn/vnf-dashboard/upsert-gescales-dock';


/**
 * All about the VNF dashboard
 */
@Injectable({ providedIn: 'root' })
export class VnfDashboardService extends BaseService {
  constructor(config: ShivaVnfSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `upsertGescalesDock()` */
  static readonly UpsertGescalesDockPath = '/custom/dock-occupancy/gescales/dock/upsert';

  /**
   * Create a Gescales Dock.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertGescalesDock()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertGescalesDock$Response(params: UpsertGescalesDock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return upsertGescalesDock(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a Gescales Dock.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upsertGescalesDock$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertGescalesDock(params: UpsertGescalesDock$Params, context?: HttpContext): Observable<void> {
    return this.upsertGescalesDock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `importGescalesData()` */
  static readonly ImportGescalesDataPath = '/custom/dock-occupancy/gescales/import';

  /**
   * Import en excel file containing Gescales forecast planning data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importGescalesData()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importGescalesData$Response(params?: ImportGescalesData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importGescalesData(this.http, this.rootUrl, params, context);
  }

  /**
   * Import en excel file containing Gescales forecast planning data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importGescalesData$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importGescalesData(params?: ImportGescalesData$Params, context?: HttpContext): Observable<void> {
    return this.importGescalesData$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getGescalesRawDataProcessProgress()` */
  static readonly GetGescalesRawDataProcessProgressPath = '/custom/dock-occupancy/gescales/progress-state';

  /**
   * Return gescales raw data treatment progress state.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGescalesRawDataProcessProgress()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGescalesRawDataProcessProgress$Response(params?: GetGescalesRawDataProcessProgress$Params, context?: HttpContext): Observable<StrictHttpResponse<GescalesRawDataProgress>> {
    return getGescalesRawDataProcessProgress(this.http, this.rootUrl, params, context);
  }

  /**
   * Return gescales raw data treatment progress state.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGescalesRawDataProcessProgress$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGescalesRawDataProcessProgress(params?: GetGescalesRawDataProcessProgress$Params, context?: HttpContext): Observable<GescalesRawDataProgress> {
    return this.getGescalesRawDataProcessProgress$Response(params, context).pipe(
      map((r: StrictHttpResponse<GescalesRawDataProgress>): GescalesRawDataProgress => r.body)
    );
  }

  /** Path part for operation `getOccupancyState()` */
  static readonly GetOccupancyStatePath = '/custom/dock-occupancy';

  /**
   * Fetch the forecast boat occupancy from gescale data, and the actual boat occupancy from DAISY.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOccupancyState()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOccupancyState$Response(params: GetOccupancyState$Params, context?: HttpContext): Observable<StrictHttpResponse<DockDailyOccupancyStateList>> {
    return getOccupancyState(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch the forecast boat occupancy from gescale data, and the actual boat occupancy from DAISY.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOccupancyState$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOccupancyState(params: GetOccupancyState$Params, context?: HttpContext): Observable<DockDailyOccupancyStateList> {
    return this.getOccupancyState$Response(params, context).pipe(
      map((r: StrictHttpResponse<DockDailyOccupancyStateList>): DockDailyOccupancyStateList => r.body)
    );
  }

}
